import axios from "axios";
import Paths from "../../constant/constant";

export async function GetUsers() {
  return await axios
    .get(Paths.API_URL + `/api/v1/getusers`)
    .then((res) => {
      return res.data;
    })
    .catch(function (e) {});
}

export async function GetUsersActive() {
  return await axios
    .get(Paths.API_URL + `/api/v1/getusersactive`)
    .then((res) => {
      return res.data;
    })
    .catch(function (e) {});
}
